import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GTULOGO from "./img/GTU.png"

const ResultformatGTU = forwardRef(({ selectedRows, clientData, examName }, ref) => {
  const [currentDateTime, setCurrentDateTime] = useState('');

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const formattedDate = now.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      const formattedTime = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      setCurrentDateTime(`${formattedDate} - ${formattedTime}`);
    };
    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useImperativeHandle(ref, () => ({
    callChildFunction() {
      generatePDF();
    }
  }));

  const students = Array.isArray(selectedRows) ? selectedRows : [];
  // this function to get grade for external



  

  function getCurrentDateTime() {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear()).slice(2);
    let hours = currentDate.getHours();
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
    return `${formattedDate} ${formattedTime}`;
  }

  const generatePDF = () => {
    const input = document.getElementById("result-content");
    const students = Array.isArray(selectedRows) ? selectedRows : [];
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 190;
    const pageHeight = 295;
    const margin = 10;
    const topMargin = 30;
    const generatePageForStudent = (student, index) => {
      const studentContent = document.getElementById(`student-${index}`);
      return html2canvas(studentContent, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = topMargin;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const xPosition = (pageWidth - imgWidth) / 2;
        pdf.addImage(imgData, "PNG", xPosition, position, imgWidth, imgHeight);
        heightLeft -= pageHeight - (topMargin + margin);
        while (heightLeft > 0) {
          position = heightLeft - imgHeight + topMargin;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", xPosition, position, imgWidth, imgHeight);
          heightLeft -= pageHeight - (topMargin + margin);
        }
        if (index < students.length - 1) {
          pdf.addPage();
        }
      });
    };

    Promise.all(students.map((student, index) => generatePageForStudent(student, index))).then(() => {
      pdf.save(`${examName}_Results.pdf`);
    });
  };
  function calculatePercentage(subjects) {
    const totalObtainedMarks =
      subjects.reduce((total, subject) => total + (subject.externalSubjectMarks + subject.omrTotalMarks || 0), 0)
    const totalPossibleMarks =
      subjects.reduce((total, subject) => total + (subject.externalTotalMarks || 0), 0)
    if (totalPossibleMarks === 0) {
      return "0.00%"; // Handle case where total possible marks are zero
    }
    const percentage = (totalObtainedMarks / totalPossibleMarks) * 100;
    return `${percentage.toFixed(2)}%`;
  }

  function calculateSPI(subjects) {
    if (!subjects || subjects.length === 0) return 0; // Handle empty or undefined subjects

    const externalMarks = subjects.reduce((total, subject) => total + (subject.externalSubjectMarks + subject.omrTotalMarks || 0), 0);

    const externalTotal = subjects.reduce((total, subject) => total + (subject.externalTotalMarks || 0), 0);


    const totalMarksObtained = externalMarks;
    const totalMaxMarks = externalTotal; // Avoid division by zero

    const spi = (totalMarksObtained / totalMaxMarks) * 10; // Convert to SPI scale
    return parseFloat(spi.toFixed(1)) || 0; // Return SPI rounded to one decimal place
  }


  return (
    <div className="container mt-5 ">
      <div className='text-end mt-3'>
      </div>
      <div id="result-content" className=" border  p-5 ">
        {students.length === 0 ? (
          <p>No students selected.</p>
        ) : (
          students.map((student, index) => (
            <div id={`student-${index}`} key={index} className=" p-4 mb-4">
              <div  >
                <div className="container text-center mb-3">
                  <div className="row">
                    <div className="col-3">
                      {getCurrentDateTime()}
                    </div>
                    <div className="col-7 text-bold">
                      {clientData.clientName} {clientData.clientCity}
                    </div>
                    <div className="col">
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row mb-3 ">
                  <div className="p-0 mx-0 ms-4 me-0"> <img src={GTULOGO} style={{ width: "150px", height: "150px" }} alt="logo" /></div>
                  <div className="p-2 mt-5"><h2 className="client-name  "> <strong>{clientData.clientName} {clientData.clientCity}</strong></h2></div>
                </div>
                <div className="row p-2 fs-5 text ms-0 mb-3 pb-4 border border-2 border-dark col-12">
                  <div className="col mt-2">
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Name:</strong></div>
                      <div className=""><span >{student.studentName}</span></div>
                    </div>
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Enrollment No:</strong></div>
                      <div className=""><span >{student.studentRollNumber}</span></div>
                    </div>
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Exam Seat No:</strong></div>
                      <div className=""><span > {student.studentRollNumber}</span></div>
                    </div>
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Exam:</strong></div>
                      <div className=""><span >{examName} </span></div>
                    </div>
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Branch:</strong></div>
                      <div className=""><span ></span></div>
                    </div>
                  </div>
                  <div className="col mt-5 ">
                    <div className="d-flex flex-row ">
                      <div className="result-labal"><strong>Declared On:</strong></div>
                      <div className=""><span >{new Date(student.resultDeclaredDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                      })}</span></div>
                    </div>
                  </div>
                </div>
                <table className="table  table-responsive mt-4 mb-3  fs-5 text ">
                  <thead className="table-light border  border-2 border-dark ">
                    <tr>
                      <th className="text-center border  border-2 border-dark border-end-0 mb-3">SUBJECT CODE</th>
                      <th className="text-center border  border-2 border-dark  p-4">SUBJECT NAME</th>
                      <th className="text-center border  border-2 border-dark border-start-0 border-end-0 p-4 ">SCORE</th>
                      <th className="text-center border  border-2 border-dark border-end-0 p-4 ">INT. SCORE</th>
                      <th className="text-center border  border-2 border-dark  p-4" >BACKLOG</th>
                    </tr>
                  </thead>
                  <tbody >
                    {student.subjects && student.subjects.length > 0 ? (
                      <>
                        {/* Loop through subjects and display each row */}
                        {student.subjects.map((subject, i) => (
                          <tr key={i}>
                            <td className="text-center col-1 border  border-2 border-dark border-end-0">{subject.subjectCode}</td>
                            <td className="col-4 border  border-2 border-dark ">{subject.subjectName}</td>
                            <td className="text-center border  border-2 border-dark border-end-0 border-start-0 ">{subject.externalSubjectMarks + subject.omrTotalMarks}</td>  {/* External Marks */}
                            <td className="text-center border  border-2 border-dark border-end-0">{subject.interSubjectMarks}</td>  {/* Internal Marks */}
                            <td className="text-center border  border-2 border-dark">
                              {subject.externalStatus === "Pass" ? "P" : "F"} --- {subject.internalStatus === "Pass" ? "P" : "F"}
                            </td>

                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="7">No subjects available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="row mt-1  justify-content-center mb-0">
                  <div className="col-md-4 border border-dark text-center mx-1" >
                    <p className="mb-0 mb-1 mt-1 "><strong>Current Sem. Backlog: </strong> <strong>
                      {student.subjects.filter(subject => subject.externalStatus === "Fail" || subject.internalStatus === "Fail").length}
                    </strong></p>
                  </div>
                  <div className="col-md-2 border border-dark text-center mx-1 ">
                    <p className="mb-0 mb-1 mt-1"><strong>Total Backlog:</strong> <strong>
                      {student.subjects.filter(subject => subject.externalStatus === "Fail" || subject.internalStatus === "Fail").length}
                    </strong></p>
                  </div>
                  <div className="col-md-2 border border-dark text-center mx-1">
                    <p className="mb-0 mb-1 mt-1">
                      <strong>SPI: </strong>
                      <strong>{calculateSPI(student.subjects)}</strong>
                    </p>
                  </div>

                  <div className="col-md-3 border border-dark text-center px-2">
                    <p className="mb-0 mb-1 mt-1">
                      <strong>Percentage:</strong>
                      <strong>{calculatePercentage(student.subjects)}</strong>
                    </p>
                  </div>

                  <div className="container text-center mt-1">
                    <div className="row">
                      <div className="col-6">
                        <strong className='text-danger'>Note :</strong>
                        <strong>This is a computer generated mark-sheet.</strong>
                      </div>
                      <div className="col-6">
                        <strong>Printed On :{currentDateTime}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="box-footer border border-dark p-2 mt-3 mb-2">
                <div className="d-flex p-2 justify-content-center mt-3 ">
                  <p className={student.subjects.every(subject => subject.externalStatus === "Pass" && subject.internalStatus === "Pass") ? "text-success fs-3  " : "text-danger fs-3 "}>
                    {student.subjects.every(subject => subject.externalStatus === "Pass" && subject.internalStatus === "Pass") ? "Congratulations!! You have passed this exam." : "Sorry, you have not passed this exam."}
                  </p>
                </div>
                <div className="d-flex p-2 justify-content-center "><p className=' text-center' style={{ color: "#990e97" }}> This is a Computer generated provisional result, please consider the Hard-copy Gradesheet as final result.
                  Result queries will be entertained till 15-days from the Result declaration date. No result queries will be entertained afterword.</p></div>
              </div>
            </div>
          ))
        )}
      </div>


    </div>
  );
});
export default ResultformatGTU;